export default "__VITE_ASSET__CVeXKEYz__"